import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MapSourceNamePipe } from './map-source-name.pipe';
import { ChainDocument, Document, ReportDocument } from '../../model';
import { RowData } from '../document/document-edit-detail-dialog.component';
import { PreviewDocument } from '../../common';
import { TranslateModule } from '@ngx-translate/core';
import { DocumentReviewBadgeComponent } from '../../common/document/document-review-badge.component';

@Component({
  selector: 'app-report-product-documents',
  templateUrl: 'report-product-documents.component.html',
  styleUrls: ['report-product-documents.component.scss'],
  imports: [DatePipe, MatIconModule, MapSourceNamePipe, TranslateModule, DocumentReviewBadgeComponent],
})
export class ReportProductDocumentsComponent {
  @Input() preview!: Record<string, PreviewDocument>;
  @Input() documents!: (ReportDocument | ChainDocument)[];
  @Output() documentClick = new EventEmitter<ReportDocument | ChainDocument>();
  docDetails: RowData[] = [];

  ngOnChanges(): void {
    this.docDetails = this.buildDocDetail();
  }

  isPixelated(doc: Document): boolean {
    return (doc as ChainDocument).preview === 'pixelated';
  }

  getDisplayTitle(doc: Document): string {
    return doc.title || doc.type?.name || '';
  }

  /** Confirmed on the report but gone from the chain — a pending removal (app#381). */
  isRemoved(doc: ReportDocument | ChainDocument): boolean {
    return (doc as ReportDocument).removed === true;
  }

  openDocument(doc: ReportDocument | ChainDocument): void {
    if (this.isPixelated(doc as Document)) {
      return;
    }
    this.documentClick.emit(doc);
  }

  private buildDocDetail() {
    return Object.values(
      this.documents
        // A pending removal no longer contributes quantities — same rule as the server's `quantities`.
        .filter((d) => !!d.details && !this.isRemoved(d))
        .flatMap((d) => JSON.parse(d.details!) as RowData[])
        .reduce(
          (acc, { name, hsCode, unit, quantity }) => {
            const key = [name, hsCode, unit].join('-');
            if (!acc[key]) {
              acc[key] = { name, hsCode, unit, quantity: 0 };
            }
            acc[key].quantity += quantity;
            return acc;
          },
          {} as Record<string, RowData>
        )
    );
  }
}
